<template>
  <div>
    <div class="check-all-holder" v-if="!hideSelection">
      <v-checkbox
        v-model="selectedAll"
        label="alle auswählen"
        :ripple="false"
        @click="allCheckCLicked"
        :disabled="disableAllSelectedCheckbox"
      ></v-checkbox>
      <v-btn
        v-if="getSelectedTreeInspections.length > 0"
        color="red"
        class="ml-4"
        @click="showDeletePopup = true"
        :disabled="mySelectedItems.length > 0 && mySelectedItems.length === tableData.length"
      >
        Löschen
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="tableData"
      :sort-by="['date']"
      :sort-desc="[true]"
      :show-select="showSelect"
      :singleSelect="singleSelect"
      :item-class="sealedRowClass"
      item-key="id"
      v-model="mySelectedItems"
      :search="performSearch"
      :page.sync="pageHistory"
      :footer-props="{'items-per-page-text':'Zeilen pro Seite'}"
      :options="sortOptions"
      @update:page="pageChange"
      @update:sort-by="(e) => sortByHandler(e, SortPages.TreeInspection)"
      @update:sort-desc="(e) => sortDescHandler(e, SortPages.TreeInspection)">
      <template #item.buttons="{item}">
        <div class="buttons-holder">
          <!-- <v-icon
            v-for="action in actions"
            :key="action.id"
            :disabled="isButtonDisabled(action, item)"
            @click="$emit(action.action, item)"
            class="green--text custom-action-icon"
            >{{ action.icons }}</v-icon
          > -->
          <img  v-for="action in actions"
            v-show="!isButtonDisabled(action, item)"
            :key="action.id"
            :class="isButtonDisabled(action, item) ? 'disabled' : ''"
            @click="$emit(action.action, item)"
            class="green--text custom-action-icon" v-bind:src="action.icons"
          />
        </div>
      </template>

      <template v-slot:body.prepend="{ headers }">
        <tr v-show="getSelectedTreeInspections.length > 0">
          <td v-for="(header, i) in headers" :key="i">
            <div v-if="i == 0">
              Total:
            </div>
            <div
              v-if="header.value == 'specialHours'"
              class="custom-green-text"
            >
              {{ totalSpecialHours + " h" }}
            </div>

            <div v-if="header.value == 'normalHours'" class="custom-green-text">
              {{ totalNormalHours + " h" }}
            </div>

            <div v-if="header.value == 'material'" class="custom-green-text">
              {{ totalMaterial + " Fr." }}
            </div>

            <div v-else>
              <!-- empty table cells for columns that don't need a sum -->
            </div>
          </td>
        </tr>
      </template>

      <template v-slot:item.date="{ item }">
        <div v-if="item.date">
          <v-icon class="custom-calendar-icon"
            >mdi-calendar-blank-outline</v-icon
          >
          <span>{{ item.date | formatDate }}</span>
        </div>
      </template>
      <template v-slot:item.treeName="{ item }">
        <div v-if="item.treeName" class="d-flex">
          <img class="custom-map-area-icon" src="../../assets/images/icons/baumliste.svg" />
          <span>{{ item.treeName }}</span>
        </div>
      </template>
      <template v-slot:item.finishDate="{ item }">
        <div v-if="item.finishDate">
          <span>{{ item.finishDate | formatFullDate }}</span>
        </div>
      </template>

      <template v-slot:item.colorTypeId="{ item }">
        <span :class="getColorClass(item.colorTypeId)"></span>
      </template>
      <template v-slot:item.sealDays="{ item }">
        <div v-if="!item.isSealed && item.sealDays > 0">
          <span>{{ item.sealDays }} Tage</span>
        </div>
        <div v-else-if="item.isSealed && !item.finishDate">
          <span >Versiegelt, aber keine Daten gefunden</span>
        </div>
        <div v-else-if="item.isSealed">
          <span >Versiegelt</span>
        </div>
      </template>
      <template v-slot:item.examinationFinishedUsers="{ item }">
        <div
          v-if="
            item.examinationFinishedUsers
              ? item.examinationFinishedUsers.length > 0
              : false
          "
          class="name-holder"
        >
          <div
            class="acc-name-duration"
            v-for="user in item.examinationFinishedUsers"
          >
            <span class="acc-name" :title="user.firstName + ' ' + user.lastName">
              <span class="initials">
               {{ user.initials ? user.initials : (user.firstName[0].toUpperCase() + user.lastName[0].toUpperCase()) }}
              </span>
              <!-- {{ user.firstName }} {{ user.lastName }} -->
            </span>
          </div>
          <div v-if="item.freelanceFirstName && item.freelanceLastName" class="acc-name-duration">
            <span class="acc-name" :title="item.freelanceFirstName + ' ' + item.freelanceLastName">
              <span class="initials">
                {{ getInitials(item.freelanceFirstName, item.freelanceLastName) }}
              </span>
            </span>
          </div>
        </div>
      </template>
      <template v-slot:item.info="{ item }">
          <span  v-if="item.info != null">
            <v-tooltip top :offset="10"> 
              <template v-slot:activator="{ on, attrs }">
                <img class="custom-map-area-icon cursor-pointer" src="../../assets/images/icons/info.svg" v-bind="attrs" v-on="on" />
              </template>
              <span>{{ item.info }}</span> 
            </v-tooltip>
          </span>
        </template>
      <template #header.data-table-select="{ }"> </template>
      <template #item.data-table-select="{ item, isSelected }">
        <div class="locked-baum-controle">
          <v-checkbox
          v-if="!hideSelection"
          color="#1DB954"
          v-model="mySelectedItems"
          :ripple="false"
          :value="item"
        ></v-checkbox>

        <v-icon v-if="item.isSealed === true" class="custom-lock-icon red" medium
          >mdi-lock-outline</v-icon>
        </div>
      </template>
    </v-data-table>
    <div class="delete-popup" v-show="showDeletePopup" ref="deletePopup">
      <div class="popup-holder">
        <v-icon size="36" class="close-popup" @click="showDeletePopup = false">mdi mdi-close</v-icon>

        <p class="title">Eintrag loschen</p>

        <div class="description-holder">
          <v-icon color="#C82210" class="popup-icon">mdi mdi-trash-can-outline</v-icon>

          <p class="description">
            Möchten Sie diese wirklich löschen? Diese Aktion kann
            nicht rückgängig gemacht werden.
          </p>
        </div>

        <div class="buttons">
          <v-btn
            size="x-large"
            height="54px"
            class="cancel-btn"
            @click="showDeletePopup = false"
          >
            Abbrechen
          </v-btn>

          <v-btn
            size="x-large"
            height="54px"
            color="#c82210"
            class="delete-btn"
            @click="deleteTasks"
          >
            Löschen
          </v-btn>
        </div>
      </div>
    </div>
    <CustomLoader v-show="isLoading" />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
import { eventBus } from "../../main";
import sortMixin from '../../mixins/sortMixin'
import { SortPages} from '../../consts/Sorts'
import CustomLoader from '@/components/custom_components/CustomLoader.vue'
import axios from 'axios'

export default {
  components: { CustomLoader },
  mixins: [sortMixin],
  props: [
    "headers",
    "tableData",
    "actions",
    "showSelect",
    "singleSelect",
    "userCanView",
    "userCanEdit",
    "userCanDelete",
    "hideSelection"
  ],
  data() {
    return {
      totalSpecialHours: 0,
      totalNormalHours: 0,
      totalMaterial: 0,
      selectedAll: false,
       localSearch: null,
      showDeletePopup: false,
      isLoading: false,
      SortPages: SortPages
    };
  },
  computed: {
     ...mapGetters([ "getSearchquery", 'getSelectedTreeInspections']),
     performSearch() {
      return this.getSearchquery;
    },
    mySelectedItems: {
      get() {
        if (this.singleSelect) {
          return [this.getSelectedTreeInspections[this.getSelectedTreeInspections.length - 1]];
        } else {
          return this.getSelectedTreeInspections;
        }
      },
      set(value) {
        if (typeof value !== "object") this.setSelectedTreeInspections([value]);
        else this.setSelectedTreeInspections(value);
      }
    },
    sealedRowClass() {
      return item => (item.isSealed ? "sealed-row" : "");
    },
    pageHistory: {
      get() {
        const savedPage = JSON.parse(localStorage.getItem('tableBaumControlCurrentPage'));
        if (this.tableData.length > 0 && savedPage !== null) {
          return savedPage;
        } else {
          return 1;
        }
      },
      set(value) {
        localStorage.setItem('tableBaumControlCurrentPage', value);
      }
    },
    disableAllSelectedCheckbox() {
      if (this.mySelectedItems.length > 0 && this.mySelectedItems.length !== this.tableData.length){
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    getSelectedTreeInspections: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.calculateSumOfColumns();
        } else {
          this.selectedAll = false;
        }
      }
    },
    tableData: function (newVal){
      if (newVal.length > 0 && this.getSelectedTreeInspections.length > 0)
        this.selectedAll = this.getSelectedTreeInspections?.length === newVal.length;
    }
  },
  mounted() {
    eventBus.$on("resetSelectedTasks", () => (this.setSelectedTreeInspections([])));
    this.localSearch = this.getSearchquery;
    this.setInitialSort(SortPages.TreeInspection)

    this.mySelectedItems = this.getSelectedTreeInspections
    this.calculateSumOfColumns()
  },
  destroyed() {
    eventBus.$off("resetSelectedTasks");
  },
  methods: {
    ...mapActions(['setSelectedTreeInspections']),
    pageChange(newPage) {
      localStorage.setItem("tableBaumControlCurrentPage", newPage);
    },
    getColorClass(colorType) {
      switch (colorType) {
        case 1:
          return 'circle red-circle';
        case 2:
          return 'circle green-circle';
        case 3:
          return 'circle blue-circle';
        case 4:
          return 'circle yellow-circle';
        case 5:
          return 'circle gray-circle';
        default:
          return 'circle gray-circle';
      }
    },
    allCheckCLicked() {
      if (this.selectedAll === true) {
        this.setSelectedTreeInspections(this.tableData);
        this.$emit('selectedRow', this.mySelectedItems);
      } else {
        this.setSelectedTreeInspections([]);
      }
    },
     handleSearch(query) {
      this.getSearchquery = query;
    },
    calculateSumOfColumns() {
      /* special hours sum */
      const sumOfSpecialHours = this.getSelectedTreeInspections.reduce(
        (accumulator, currentItem) => {
          return accumulator + currentItem.specialHours;
        },
        0
      );

      /* normal hours sum */
      const sumOfNormalHours = this.getSelectedTreeInspections.reduce(
        (accumulator, currentItem) => {
          return accumulator + currentItem.normalHours;
        },
        0
      );

      /* material sum */
      const sumOfMaterial = this.getSelectedTreeInspections.reduce(
        (accumulator, currentItem) => {
          return accumulator + currentItem.material;
        },
        0
      );

      this.totalSpecialHours = sumOfSpecialHours;
      this.totalNormalHours = sumOfNormalHours;
      this.totalMaterial = sumOfMaterial;
    },

    isButtonDisabled(action, item) {
      if (this.userCanView === true && action.action === "view") {
        if(item.isFinished === false) {
          return true;
        } else {
          return false;
        }
      } else if (this.userCanEdit === true && action.action === "edit") {
        if(item.isFinished === true) {
          return true;
        } else {
          return false;
        }
      } else if (this.userCanEdit === true && action.action === "createEditBaumK") {
        if(item.isSealed === true) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },

    /* function that provides initials and handles if name or surname has spaces */
    getInitials(name, surname) {
      let nameInitials = "";
      if (name) {
        nameInitials = name
          .split(" ")
          .map(n => n.charAt(0))
          .join("");
      }
      let surnameInitials = "";
      if (surname) {
        surnameInitials = surname
          .split(" ")
          .map(n => n.charAt(0))
          .join("");
      }
      return (nameInitials + surnameInitials).toUpperCase() || "";
    },

    async deleteTasks() {
      if (!this.getSelectedTreeInspections || this.getSelectedTreeInspections.length === 0) {
        alert("No tasks selected for deletion.");
        return;
      }
      this.isLoading = true;
      const taskIds = this.getSelectedTreeInspections.map(item => item.id);

      try {
        const response = await axios.delete("/api/Tasks/Delete", {
          data: taskIds,
        });

        if (response.status === 200 && response.data.success) {
          this.$emit('removeTasks', taskIds);
          await this.setSelectedTreeInspections([]);
          this.selectedAll = false;
          this.showDeletePopup = false;
        } else {
          alert("Failed to delete tasks: " + response.data.message);
        }
      } catch (error) {
        alert("Error deleting tasks: " + error.message);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss">

.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
}
.check-all-holder {
  padding-left: 5px;
  padding-top: 16px;
  display: flex;
  align-items: center;
}
.custom-action-icon {
  border: 1px solid #494949;
  padding: 8px;
  border-radius: 5px;
  width: 42px;
  height: 42px;

  &::after {
    border-radius: 5px;
    width: 42px;
    height: 42px;
    transform: scale(1);
  }
}

.custom-green-text {
  color: #1db954;
}

.custom-calendar-icon {
  margin-right: 5px;
}

.custom-lock-icon {
  padding: 5px;
}

.buttons-holder {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.name-holder {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 10px;

  .acc-name-duration {
    margin-top: 0;
    margin-bottom: 0;

    .acc-name {
      text-transform: capitalize;
      display: flex;
      align-items: center;
      margin-bottom: 0;

      .initials {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #494949;
        padding: 8px;
        border-radius: 100%;
        margin-right: 0;
        text-transform: uppercase;
        font-size: 10px;
        font-weight: 500;
        color: #1db954;
        width: 36px;
        height: 36px;
        cursor: default;
      }
    }

    .duration {
      margin-left: 46px;
    }
  }
}

.three-buttons {
  display: flex !important;
  align-items: center;
  justify-content: flex-end;
  gap: 30px;

  .custom-outlined {
    min-width: 138px !important;
    border-radius: 5px !important;
    opacity: 1 !important;
    border-left-width: 1px !important;

    &.custom-active {
      background-color: #1db954 !important;

      .v-btn__content {
        color: black;
      }

      &::before {
        opacity: 0;
      }
    }
  }
}

.sealed-row {
  td {
    border-top: 1px solid;
    box-shadow: none !important;
    border-bottom: 1px solid !important;
    border-color: red !important;

    &:first-child {
      border-left: 1px solid;
    }

    &:last-child {
      border-right: 1px solid;
    }
    .locked-baum-controle{
      display: flex;
      align-content: center;
    }
  }
  // pointer-events: none !important;

  &:hover {
    background: transparent !important;
  }
}
/* Red */
.red-circle {
  background-color: #c82210;
}

/* Green */
.green-circle {
  background-color: #1db954;
}

/* Blue */
.blue-circle {
  background-color: #118afa;
}

/* Yellow */
.yellow-circle {
  background-color: #fff500;
}

/* Gray */
.gray-circle {
  background-color: gray;
}

.circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}
.popup,
.confirm-popup,
.delete-popup,
.cancel-popup {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.3);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;

  .popup-holder {
    display: flex;
    flex-direction: column;
    background-color: #1c1e1c;
    width: 662px;
    height: auto;
    max-height: 78vh;
    max-height: 80%;
    border-radius: 10px;
    padding: 30px;
    position: relative;

    .close-popup {
      position: absolute;
      right: 30px;
      top: 25px;
      cursor: pointer;
    }

    .title {
      text-align: center;
    }

    .description-holder {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      height: 200px;

      .popup-icon {
        margin-bottom: 20px;
        font-size: 50px;
      }

      .description {
        font-size: 18px;
        line-height: 25px;
        margin-bottom: 0;
        text-align: center;
      }
    }

    .work-types,
    .baums {
      height: 100%;
      max-height: 304px;
      overflow-y: auto;
      overflow-x: hidden;

      &::-webkit-scrollbar {
        width: 3px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: transparent;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #1db954;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: darken($color: #1db954, $amount: 5);
      }

      .custom-radio {
        padding: 20px 0;
        border-bottom: 1px solid #494949;
      }
    }

    .buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 30px;

      .submit-btn {
        width: 285px;
        color: #000;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        text-transform: none;
        background-color: #1db954;
      }

      .delete-btn {
        width: 285px;
        color: #fff;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        text-transform: none;
        background-color: #c82210;
      }

      .cancel-btn {
        width: 285px;
        color: #fff;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        text-transform: none;
        background-color: transparent;
        border: 1px solid #fff;
      }
    }
  }
}
</style>
